import "./index.css";
import { useState, useEffect } from "react";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "./supabaseClient.js";

export default function App() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (!session) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
        }}
      >
        <div style={{ padding: "20px" }}>
          <img src="/myrecycle-icon.png" alt="Logo" />
        </div>
        <Auth
          supabaseClient={supabase}
          localization={{
            variables: {
              sign_in: {
                social_provider_text: "Continue with {{provider}}",
              },
            },
          }}
          appearance={{
            theme: ThemeSupa,
            style: {
              button: { borderColor: "#45995C", color: "#45995C" },
              anchor: { color: "blue" },
            },
          }}
          providers={["google"]}
          onlyThirdPartyProviders={true} // to hide email-password
        />
      </div>
    );
  } else {
    return <div>Logged in!</div>;
  }
}
